// extracted by mini-css-extract-plugin
export default {"thanks":"Thanks_thanks__ao3Xy","thanks__alert":"Thanks_thanks__alert__yeeX2"};